import type {
  ButtonColor,
} from './types';

export const buttonColors = {
  DEFAULT: 'default' as ButtonColor,
  PRIMARY: 'primary' as ButtonColor,
  TERTIARY: 'tertiary' as ButtonColor,
  GHOST: 'ghost' as ButtonColor,
  DANGER: 'danger' as ButtonColor,
  DANGER_TERTIARY: 'danger_tertiary' as ButtonColor,
  DANGER_GHOST: 'danger_ghost' as ButtonColor,
  PRIMARY_GHOST: 'primary_ghost' as ButtonColor,
};
